import { useContext } from 'react';
import { GlobalContext } from '../../GlobalContext';

/**
 * Breakpoint enum for media queries using max-width approach.
 * Values represent the maximum viewport width in pixels for each breakpoint.
 *
 * @property {number} XS - Extra small devices (phones) - 480px and down
 * @property {number} SM - Small devices (tablets) - 768px and down
 * @property {number} MD - Medium devices (small laptops) - 1024px and down
 */
export enum BreakpointsEnum {
    XS = 480,
    SM = 768,
    MD = 1024,
    LG = 1280
}

/**
 * Custom hook for max-width based media queries.
 * Returns true when the viewport width is at or below the specified breakpoint.
 * This follows a desktop-first approach as this project was initially built for desktop only.
 *
 * @param {BreakpointsEnum | number} breakpoint - The maximum width breakpoint from BreakpointsEnum
 * @returns {boolean} - true if viewport width <= breakpoint, false otherwise
 */
export const useMediaQuery = (breakpoint: BreakpointsEnum | number): boolean => {
    const { wWidth } = useContext(GlobalContext);

    return wWidth <= breakpoint;
};
